import { z } from 'zod'
import { asEnumType } from '@gqloom/zod'
import type { ScoreBand } from './score-band-schemas'

export const formExternalResultSourceSchema = z
  .enum(['MIGRATION', 'STAFF_ASSIGNED'])
  .register(asEnumType, {
    name: 'FormExternalResultSource',
    description:
      'Where a result recorded outside Hapana came from: a migration from another system, or staff recording an assessment done elsewhere',
  })

export const FORM_EXTERNAL_RESULT_SOURCE = formExternalResultSourceSchema.enum

export const FORM_EXTERNAL_RESULT_NOTE_MAX_LENGTH = 255

export const formExternalResultInvalidReasonSchema = z.enum([
  'BAND_NOT_IN_FORM',
  'FORM_NOT_SCORED',
  'ASSESSED_IN_FUTURE',
  'OLDER_THAN_CURRENT',
  'FORM_AMBIGUOUS',
  'LABEL_UNRECOGNISED',
])

export const FORM_EXTERNAL_RESULT_INVALID_REASON = formExternalResultInvalidReasonSchema.enum

export const recordExternalFormResultInputSchema = z.object({
  siteId: z.string(),
  clientId: z.string(),
  siteFormId: z.string().min(1).max(36),
  bandId: z.uuid(),
  assessedAt: z.coerce.date(),
  source: formExternalResultSourceSchema,
  note: z.string().trim().max(FORM_EXTERNAL_RESULT_NOTE_MAX_LENGTH).nullish(),
})

export type FormExternalResultSource = z.infer<typeof formExternalResultSourceSchema>
export type FormExternalResultInvalidReason = z.infer<typeof formExternalResultInvalidReasonSchema>
export type RecordExternalFormResultInput = z.infer<typeof recordExternalFormResultInputSchema>

const SKIN_TYPE_NUMERALS = ['I', 'II', 'III', 'IV', 'V', 'VI'] as const
const SKIN_TYPE_PREFIX = /^type\s+/i

export const SKIN_TYPE_LABELS = SKIN_TYPE_NUMERALS.map((numeral) => `Type ${numeral}`)

export function normalizeSkinTypeLabel(raw: string): string | null {
  const numeral = raw.trim().replace(SKIN_TYPE_PREFIX, '').trim().toUpperCase()
  return SKIN_TYPE_NUMERALS.find((candidate) => candidate === numeral) ? `Type ${numeral}` : null
}

export function findBandByLabel(bands: ScoreBand[], label: string): ScoreBand | null {
  return bands.find((band) => band.label.trim() === label) ?? null
}
